export const initialState = () => ({
  campaign: {
    name: "",
    active: false,
    undefinedEndDate: false,
    start_date: null,
    end_date: null,
    editingDatesValidation: {
      start_date: null,
      end_date: null
    }
  }
})
